const config = {
    title: '',
};
export default config;